import Component from '@glimmer/component';
import { task, timeout } from 'ember-concurrency';
import { task as trackedTask } from 'reactiveweb/ember-concurrency';
import { inject as service } from '@ember/service';
import _, { sortBy } from 'lodash';
import startOfDay from "@dubbletrack/time/utils/start-of-day";
import endOfDay from "@dubbletrack/time/utils/end-of-day";

export default class DeluxePlayerScheduleDayComponent extends Component {
  @service clock;
  @service store;

  triggerLoadTask = task({restartable: true, maxConcurrency: 1}, async reload => {
    // console.log('waiting for load timeout', this.args.date)
    await timeout(200);
    // console.log('triggering on load', this.args.date)
    this.args.onLoad(reload)
  });

  _airingsForDateTask = task(async () => {
    return sortBy(
        this.store
          .peekAll('airing')
          .filter(
            (a) =>
              new Date(a.startsAt) >= startOfDay(this.args.date, { timeZone: this.clock.timeZone }) &&
              new Date(a.startsAt) < endOfDay(this.args.date, { timeZone: this.clock.timeZone }),
          ),
        ['startsAt'],
      );
  })

  airingsForDateTask = trackedTask(this, this._airingsForDateTask, () => [this.clock.timeZone])
}
